"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useReferenceElementWidth = require("./useReferenceElementWidth");
Object.keys(_useReferenceElementWidth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useReferenceElementWidth[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useReferenceElementWidth[key];
    }
  });
});